<script>
import Router from "svelte-spa-router";
import {
    environment
} from "@app/store/envStore.svelte.js";
import {
    replace
} from "svelte-spa-router";
// Import the list of routes
import routes from "./routes.js";

function conditionsFailed(detail) {
    // Perform any action, for example replacing the current route
    if (environment.iframe && !environment.online){
        replace("/");
    } else if (environment.online){
        if (detail.location === "/" || detail.location === "/signup") {
            replace("/login");
        } else if (detail.location === "/login") {
            replace("/");
        }
    } else {
        if (detail.location === "/") {
            replace("/loginOffline");
        } else if (detail.location === "/loginOffline") {
            replace("/");
        }
    }
}
</script>

<div>
    <Router
        {routes}
        onConditionsFailed={conditionsFailed}
        />
</div>
